import Vue from 'vue'
import configs from '@/config'

// Legacy Tenor API client kept during AHA-42116 rollout.
// When `canUseKlipyGifProvider` is OFF, the picker calls this client which
// hits the BE `/search-tenor` endpoint (still registered, see backend PR #1886).
// When the flag is ON, the picker uses `gifProvider.js` -> `/search-gif` instead.
// This file should be removed once the Klipy flag is fully rolled out.
let resource = null

const actions = {
  search: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/search-tenor`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const search = async (params = {}) => {
  const result = await resource.search({
    limit: params.limit,
    media_filter: params.media_filter,
    searchfilter: params.searchfilter,
    pos: params.pos,
    q: params.q,
  })

  return result.body
}

export default {
  initResource,
  search,
}
